// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3s3wa","label":"Section_label__2DdLX","contentWrap":"Section_contentWrap__3noN6","footer":"Section_footer__1Oq32","footerInner":"Section_footerInner__wlQgd"};